// extracted by mini-css-extract-plugin
module.exports = {"promotional":"styles_promotional__KHvWv","promotional__carousel":"styles_promotional__carousel__Mir0U"};